export const apiResponse = (action) => {
    const { prefix, filter } = action;

    return {
        type: prefix + filter,
        ...action
    };
};
